import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { type CellContext, RowActionsWrapper } from "@msuite/ui/table";
import React from "react";
import { EditDefaultApproversModal } from "@/modals/incoming-invoices/edit-default-approvers-modal";
import type { InvoiceDefaultApproverSet } from "./invoice-default-approver-sets";

export function InvoiceDefaultApproversRowActions({
	cell,
}: CellContext<InvoiceDefaultApproverSet, "actions">) {
	/** Hooks */
	const editModal = useDisclosure();

	/** Render */
	return (
		<React.Fragment>
			<RowActionsWrapper to={null}>
				<Button
					icon={<Icon name="Edit" />}
					size="xxs"
					variant="ghost"
					onClick={editModal.onOpen}
					data-cy="edit-default-approvers-button"
				/>
			</RowActionsWrapper>
			{editModal.isOpen && (
				<EditDefaultApproversModal
					workspaceId={cell.row.original.workspaceId}
					name={cell.row.original.name}
					isOpen={editModal.isOpen}
					onClose={editModal.onClose}
				/>
			)}
		</React.Fragment>
	);
}
